var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page page-content"},[_c('Block',{staticClass:"error-block"},[_c('h1',[_vm._v("Une erreur est survenue")]),_c('p',[_vm._v("Veuillez réessayer ultérieurement")]),_c('span',[_vm._v(_vm._s(_vm.errorMessage))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }